import { invoiceKind, invoicePostingState } from '@/lib/constants/invoices'

export const totalHoursLabel = (invoice) => {
  if (!invoice || invoice.kindId !== invoiceKind.TimeSheet || invoice.totalHours == null) return ''
  return String(invoice.totalHours)
}

export const attemptTriggerLabel = (attempt) => {
  if (!attempt || !attempt.triggeredByUserId) return 'Daily job'
  return attempt.triggeredByUserName || `User #${attempt.triggeredByUserId}`
}

export const canPostInvoice = (invoice) =>
  !!invoice && [invoicePostingState.NotPosted, invoicePostingState.Failed].includes(invoice.postingStateId)

export const canRepostInvoice = (invoice) =>
  !!invoice && invoice.postingStateId === invoicePostingState.ChangedAfterPosting
